<div class="container">
  <p class="message-title">
    {{ data.message }}
  </p>
  <div class="dimiss" (click)="dimiss()">متوجه شدم</div>
</div>
